<div *ngIf="isShoppingFunnel" class="container">
  <div class="row d-flex justify-content-center">
    <div class="col-md-10">
      <div class="" *ngIf = 'welDone != true' >
        <form (ngSubmit)="onSubmit()" #loginForm="ngForm">
          <div class="form-group row has-danger" *ngIf="welDone == false">
            <div class="col-12">
              <div class="form-control-feedback"><i class="fa fa-exclamation-circle" aria-hidden="true"></i> Veuillez saisr un mail valide</div>
            </div>
          </div>
          <!-- email field -->
          <div class="form-group row" [ngClass]="{'has-danger':  (email.errors?.email && email.touched) || errorMsg }">
            <div class="col-12">
              <div class="mb-2 mr-sm-2 mb-sm-0">
                <div class="center">
                  <i class="fa fa-envelope" aria-hidden="true"></i>
                </div>
                <input class="form-control border-radius-none heigh-50" type="email" value="" id="email" name="email" placeholder="{{'shared_login_reset_form.email'| translate}}" [(ngModel)]="user.email" #email="ngModel" required email>
              </div>
              <div class="form-control-feedback" *ngIf="email.touched && email.dirty && user.email.length<=0"><i class="fa fa-info-circle" aria-hidden="true"></i> {{'shared_login_reset_form.your_mail_adress_is_required'| translate}}</div>
              <div class="form-control-feedback" *ngIf="email.touched && !email.valid && user.email.length>0 "><i class="fa fa-info-circle" aria-hidden="true"></i> {{'shared_login_reset_form.your_mail_adress_is_invalid'| translate}}</div>
            </div>
          </div>
          <!-- password field -->
          <div class="form-group row ">
            <div class="offset-sm-1 col-sm-10 text-center">
              <div style="text-align: center;" *ngIf="onloading" >
                <i class="fa fa-spinner"  style="font-size: 35px;margin-bottom: 15px;" aria-hidden="true" ></i>
              </div>
              <button type="submit" *ngIf="!onloading" class="send-btn color-gb white" [disabled]="!loginForm.form.valid || onloading == true">{{'shared_login_reset_form.send'| translate}}</button>
            </div>
          </div>
        </form>
        <div class="displayLinks row">
          <div class="col-6 rp-xs">
            <div class="my-3 text-left"><a routerLink="/login/signin">{{'shared_login_reset_form.send'| translate}}</a></div>
          </div>
          <div class="col-6 rp-xs">
            <div class="my-3 text-right"><a routerLink="/login/signup">{{'shared_login_reset_form.create_an_account'| translate}}</a></div>
          </div>
        </div>

      </div>

      <section *ngIf = 'welDone == true'>
        <div style="padding : 10px;" >
          <div class="alert alert-success" role="alert">
            <i class="fa fa-info-circle" aria-hidden="true"></i> {{'shared_login_reset_form.an_mail_has_been_sent_to_you'| translate}}
          </div>
        </div>
      </section>

    </div>

  </div>
</div>

<div *ngIf="!isShoppingFunnel" class="heigh-900p row col-md-12 pd-lr-0 mlr-0">
  <div class="col-md-4 reset-first-bg">
    <div class="center pt-100p">
      <a href="/">
        <img style="width: 250px" src="assets/imgs/{{logoName}}" alt="Logo Akces" id="logo">
      </a>
    </div>
    <div class="reinit-pass reinit-pass-mini white web-black">
      Réinitialisez votre <span class="passwd-clr">mot de passe </span>:
    </div>
    <div class="enter-email center mt-3p mb-40p white web-black">Saisissez l'email associé à votre  compte. Un email vous sera envoyé pour réinitialiser votre mot de passe.</div>

    <div class="" *ngIf = 'welDone != true'>
      <form (ngSubmit)="onSubmit()" #loginForm="ngForm" class="form-pd">
        <div class="form-group row has-danger" *ngIf="welDone == false">
          <div class="col-12">
            <div class="form-control-feedback"><i class="fa fa-exclamation-circle" aria-hidden="true"></i> Veuillez saisr un mail valide</div>
          </div>
        </div>
        <!-- email field -->
        <div class="form-group row" [ngClass]="{'has-danger':  (email.errors?.email && email.touched) || errorMsg }">
          <div class="col-12">
            <div class="input-group mb-2 mr-sm-2 mb-sm-0">
              <input class="form-control border-radius-none heigh-50" type="email" value="" id="email" name="email" placeholder="E-MAIL" [(ngModel)]="user.email" #email="ngModel" required email>
            </div>
            <div class="form-control-feedback" *ngIf="email.touched && email.dirty && user.email.length<=0"><i class="fa fa-info-circle" aria-hidden="true"></i> {{'shared_login_reset_form.your_mail_adress_is_required'| translate}}</div>
            <div class="form-control-feedback" *ngIf="email.touched && !email.valid && user.email.length>0 "><i class="fa fa-info-circle" aria-hidden="true"></i> {{'shared_login_reset_form.your_mail_adress_is_invalid'| translate}}</div>
          </div>
        </div>
        <!-- password field -->
        <div class="form-group row">
          <div class="offset-sm-1 col-sm-10">
            <div style="text-align: center;" *ngIf="onloading" >
              <i class="fa fa-spinner" aria-hidden="true" ></i>
            </div>
            <div class="center mt-30p">
              <button type="submit" *ngIf="!onloading" class="color-gb white send-btn" [disabled]="!loginForm.form.valid || onloading == true">{{'shared_login_reset_form.send'| translate}}</button>
            </div>
          </div>
        </div>
      </form>
      <div class="uppercase center fs-11p mt-20p white web-black">Vous n'avez pas encore créer de compte? <a routerLink="/login/signup">Inscrivez-vous</a></div>
    </div>

    <section *ngIf = 'welDone == true'>
      <div style="padding : 10px;">
        <div class="alert alert-success" role="alert">
           {{'shared_login_reset_form.an_mail_has_been_sent_to_you'| translate}}
        </div>
      </div>
    </section>
  </div>
  <div class="col-md-8 bgImage pd-lr-0 hide-second-bloc-mini">
  </div>
</div>
